import { render, staticRenderFns } from "./FetchOrder.vue?vue&type=template&id=d6f5264e&scoped=true&"
import script from "./FetchOrder.vue?vue&type=script&lang=js&"
export * from "./FetchOrder.vue?vue&type=script&lang=js&"
import style0 from "./FetchOrder.vue?vue&type=style&index=0&id=d6f5264e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f5264e",
  null
  
)

export default component.exports